import get from "lodash/get";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function useDap() {
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const scriptTag = document.createElement('script');
    const dapProduction = get(process.env, "REACT_APP_DAP_PRODUCTION", false);
    scriptTag.async = true;
    scriptTag.src = `https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=GSA&sitetopic=acr${dapProduction ? "" : "&dapdev=true"}`;
    scriptTag.id = "_fed_an_ua_tag";
    scriptTag.type = "text/javascript";
    scriptTag.addEventListener('load', () => setLoaded(true));
    document.body.appendChild(scriptTag);
  }, []);

  useEffect(() => {
    if(!loaded){
      return;
    }

    // eslint-disable-next-line no-undef
    gas('send', 'pageview', location.pathname, document.title);
  }, [loaded])
}
